import Reveal from "@/components/Reveal";

const BARS = 28;

export default function CoreMessage() {
  return (
    <section
      data-testid="core-message-section"
      className="relative overflow-hidden bg-gradient-to-b from-transparent via-violet-950/20 to-transparent px-5 py-28 text-center sm:py-40"
    >
      {/* sacred geometry rings */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <svg className="animate-spin-slower h-[130vmin] w-[130vmin] opacity-25" viewBox="0 0 400 400" fill="none">
          <circle cx="200" cy="200" r="190" stroke="#8b5cf6" strokeOpacity="0.5" strokeDasharray="2 10" />
          <circle cx="200" cy="200" r="150" stroke="#00f5d4" strokeOpacity="0.35" strokeDasharray="1 8" />
          <circle cx="200" cy="200" r="110" stroke="#8b5cf6" strokeOpacity="0.4" strokeDasharray="4 14" />
        </svg>
      </div>
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <svg className="animate-spin-slower-rev h-[90vmin] w-[90vmin] opacity-20" viewBox="0 0 400 400" fill="none">
          <polygon points="200,40 360,300 40,300" stroke="#00d2ff" strokeOpacity="0.5" />
          <polygon points="200,360 40,100 360,100" stroke="#d946ef" strokeOpacity="0.35" />
        </svg>
      </div>

      {/* frequency bars */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 flex h-40 items-end justify-center gap-1.5 opacity-30">
        {Array.from({ length: BARS }).map((_, i) => (
          <span
            key={i}
            className="eq-bar w-1.5 bg-gradient-to-t from-violet-500 via-cyan-400 to-transparent sm:w-2"
            style={{ height: `${30 + 70 * Math.abs(Math.sin(i * 0.9))}%`, animationDelay: `${i * 0.12}s` }}
          />
        ))}
      </div>

      <div className="relative z-10 mx-auto max-w-4xl">
        <Reveal>
          <p className="eyebrow mb-10" data-testid="core-message-eyebrow">Remember</p>
        </Reveal>
        <Reveal delay={0.15}>
          <blockquote
            data-testid="core-message-quote"
            className="font-quote text-3xl italic leading-snug text-slate-100 sm:text-4xl md:text-5xl"
          >
            “You don't have to become someone else.
            <br />
            You have to remember who you are.”
          </blockquote>
        </Reveal>
        <Reveal delay={0.3}>
          <p
            data-testid="core-message-callout"
            className="font-display text-glow-cyan mt-14 text-lg font-bold uppercase tracking-[0.4em] text-cyan-300 sm:text-xl"
          >
            The Shift Starts Within.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
